import { CspConfigs } from "components/Integrations/types";

import { splunkStackResourceInstaller } from "./resource";
import { SplunkStackIntegrationInstaller } from "./types";

export const splunkStackIntegrationInstaller = (
  cspConfigs: Omit<CspConfigs, "self-hosted">
): SplunkStackIntegrationInstaller => ({
  base: {},
  "iam-write": splunkStackResourceInstaller(cspConfigs),
});
